import { z } from 'zod';

import { AvailabilitySearchUrlQuery } from './search-url-query.validator';

export const FilterSearchUrlQuerySchema = z
  .object({
    rateCode: z.array(z.string()).optional(),
    roomCode: z.array(z.string()).optional(),
  })
  .optional();

/**
 * Takes serialised filter URL query
 * and transforms it to a validateable filter object.
 * E.g. { 'filter.rateCode': 'RA1', 'filter.roomCode': ['RC1', 'RC2'] }
 * is transformed to: filter: { rateCode: ['RA1'], roomCode: ['RC1', 'RC2'] }
 * @param query
 * @returns
 */
export const transformFilterSearchUrlQuery = (
  query: Record<string, string | string[] | undefined>
) => {
  const filter: AvailabilitySearchUrlQuery['filter'] = {};

  if (query['filter.rateCode']) {
    filter.rateCode = Array.isArray(query['filter.rateCode'])
      ? query['filter.rateCode']
      : [query['filter.rateCode']];
  }

  if (query['filter.roomCode']) {
    filter.roomCode = Array.isArray(query['filter.roomCode'])
      ? query['filter.roomCode']
      : [query['filter.roomCode']];
  }

  // Only return filter if at least one is present
  return Object.keys(filter).length > 0 ? filter : undefined;
};
